import { render, staticRenderFns } from "./ParapharmacyProductItem.vue?vue&type=template&id=48a3710a"
import script from "./ParapharmacyProductItem.vue?vue&type=script&lang=js"
export * from "./ParapharmacyProductItem.vue?vue&type=script&lang=js"
import style0 from "./ParapharmacyProductItem.vue?vue&type=style&index=0&id=48a3710a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports